<template>
	<BaseTooltip
		:disabled="tipAlwaysOn ? false : !visible"
		:text="tip"
		location="bottom"
	>
		<template #activator="{ tooltipOn }">
			<BaseBadge
				:bordered="!unBordered"
				:color="color"
				:icon="icon"
				:inline="inline"
				:offset-x="offsetX"
				:offset-y="offsetY"
				:overlap="!noOverlap"
				:visible="visible"
				:style="badgeStyle"
			>
				<template #default>
					<div v-on="{ tooltipOn }">
						<slot :lock-active="visible"></slot>
					</div>
				</template>
			</BaseBadge>
		</template>
	</BaseTooltip>
</template>

<script>
import BaseBadge from 'components/templates/Badges/BaseBadge'
import BaseTooltip from 'components/templates/Tooltips/BaseTooltip'

export default {
	name: 'LockBadge',
	components: { BaseBadge, BaseTooltip },
	props: {
		color: { type: String, default: 'primary' },
		visible: { type: Boolean, default: false },
		noOverlap: { type: Boolean, default: false },
		unBordered: { type: Boolean, default: false },
		inline: { type: Boolean, default: false },
		offsetY: { type: Number, default: undefined },
		offsetX: { type: Number, default: undefined },
		tip: { type: String, default: 'Ist nicht Teil ihres Abos' },
		tipAlwaysOn: { type: Boolean, default: false },
		badgeStyle: { type: [String, Object], default: undefined },
	},
	data: () => ({
		icon: 'fa-solid fa-lock',
	}),
}
</script>

<style></style>
